type MarketingEvent = "AddToCart" | "InitiateCheckout" | "Lead";
type MarketingChoice = "granted" | "denied" | null;

interface MarketingApi {
  choice(): MarketingChoice;
  page(path: string): void;
  track(name: MarketingEvent, parameters?: Record<string, unknown>): void;
  grant(): void;
  deny(): void;
}

function api(): MarketingApi | undefined {
  return (window as Window & { BlessedMarketing?: MarketingApi }).BlessedMarketing;
}

export const marketingChoice = () => api()?.choice() ?? null;
export const trackPage = (path: string) => api()?.page(path);
export const trackMarketing = (name: MarketingEvent, parameters?: Record<string, unknown>) => api()?.track(name, parameters);
export const grantMarketing = () => api()?.grant();
export const denyMarketing = () => api()?.deny();
